<template>
  <path
    d="M20 2.00024H4C2.9 2.00024 2 2.90024 2 4.00024V22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00024C22 2.90024 21.1 2.00024 20 2.00024ZM5.63 13.1902L8.12 9.99024C8.32 9.74024 8.7 9.73024 8.9 9.98024L11 12.5102L14.1 8.52024C14.3 8.26024 14.7 8.26024 14.9 8.53024L18.41 13.2102C18.66 13.5402 18.42 14.0102 18.01 14.0102H6.02C5.61 14.0002 5.37 13.5202 5.63 13.1902Z"
  />
</template>
